<template>
    <div>
        <app-sub-title text="Filtros" />
        <b-row>
            <b-col cols="12" md="6" lg="3">
                <app-form-text-input 
                    placeholder="Nombre tarea"
                    v-model="filters.name"
                />
            </b-col>
            <b-col cols="12" md="6" lg="3">
                <b-button-group class="btn-block">
                    <b-button class="btn-block" :variant="filters.status === 'solved'?'success':'secondary'" @click="setDate('resueltas')" > Resueltas sin aprobar</b-button>
                    <b-button :variant="filters.date === -1?'success':'secondary'" @click="setDate('vencidas')" > Vencidas</b-button>
                </b-button-group>
            </b-col>
            <b-col cols="12" md="6" lg="3">
                <app-autocomplete
                    placeholder="Creador"
                    :items="creators"
                    v-model="selectCreator"
                /> 
            </b-col>
            <b-col cols="12" md="6" lg="3">
                <app-autocomplete
                    placeholder="Responsable"
                    :items="assignedUsers"
                    v-model="selectAssignee"
                /> 
            </b-col>
            <b-col cols="12" md="6" lg="1" offset-lg="10">
                <b-button class="btn-block" variant="primary" @click="onFilter"><i class="fa fa-filter"></i></b-button>
            </b-col>
            <b-col cols="12" md="6" lg="1">
                <b-button class="btn-block" variant="secondary" @click="cleanFilter"><i class="fa fa-times-circle"></i></b-button>
            </b-col>
            
        </b-row>
    </div>
</template>
<script>
import Autocomplete from '../../../../UI/Controls/AutocompleteV2/Autocomplete.vue';
export default {
    components: {
        appAutocomplete: Autocomplete
    },
    props: {
        creators: {
            type: Array
        },
        assignedUsers: {
            type: Array
        }
    },
    data(){
        return {
            filters: {
                name: '',
                date: '',
                status: ''
            },
            selectCreator: '',
            selectAssignee: ''
        }
    },

    methods:{
        onFilter(){
            this.$emit('filter', this.filters);
        },
        cleanFilter(){
            this.selectCreator = '';
            this.selectAssignee = '';
            Object.keys(this.filters).map(key => (this.filters[key] = ''));
            this.$emit('clean', this.filters);
        },
        setDate(option){
            if(option === 'resueltas'){
                this.filters.status = 'solved';
                this.filters.date = '';
            }else if(option === 'vencidas'){
                this.filters.date = -1;
                this.filters.status = '';
            }
            this.onFilter();
        }
    },
    watch:{
        selectCreator(val){
            if(!val){
                this.filters.user= '';
                this.selectCreator = '';
            }else{
                this.filters.user = val.id;
            }
        },
        selectAssignee(val){
            if(!val){
                this.filters.assignee= '';
                this.selectAssignee = '';
            }else{
                this.filters.assignee = val.id;
            }
        }
    },

    created(){
        this.$bus.$on('filters.clean', this.cleanFilter);  
    }
}
</script>
